/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import { trackStartDesign } from "../design-tag/utils/trackNeckLabelEvent";

export default function DesignTagCreationPanel({ ...restProps }) {
  function backgroundImageStyle() {
    const imageUrl = remoteImageStaticUrl("gen/neck-label-start-design-zone.png", {
      ixlib: "rb-0.3.5",
      w: 550,
      dpr: 2
    });
    return `background-image: url("${imageUrl}"); background-size: cover;`;
  }

  function trackNeckLabelStartDesign() {
    trackStartDesign({
      location: "pdp"
    });
  }

  return (
    <div
      {...restProps}
      className={cn(
        "relative flex h-96 items-center justify-center rounded-lg border border-gray-300 bg-gray-200 bg-center bg-no-repeat"
      )}
      style={backgroundImageStyle()}
    >
      <div className={cn("neck-label-builder mx-auto max-w-sm rounded-lg bg-blue-50/80 p-2")}>
        <div className={cn("rounded-lg border-2 border-dashed border-blue-300 p-4")}>
          <div className={cn("mb-2")}>
            <a
              className={cn(
                "inline-block w-full cursor-pointer rounded-lg !bg-[#2563eb] px-4 py-3 text-center text-white !no-underline transition-colors duration-200 ease-in-out hover:!bg-[#1d4ed8] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
              )}
              href="/design-tag"
              data-testid="build-your-neck-label-button"
              onClick={trackNeckLabelStartDesign}
            >
              <span className={cn("text-base font-semibold text-white")}>
                Build Your Neck Label
              </span>
            </a>
          </div>
          <div className={cn("mb-2 flex items-center justify-center")}>
            <div className={cn("h-px flex-1 bg-blue-400")} />
            <div className={cn("px-4 text-base font-bold text-gray-900")}>2XL</div>
            <div className={cn("h-px flex-1 bg-blue-400")} />
          </div>
          <div className={cn("mb-2 space-y-1 text-center text-gray-800")}>
            <div className={cn("m-0 text-xs font-semibold")}>70% COTTON</div>
            <div className={cn("m-0 text-xs font-semibold")}>30% POLYESTER</div>
          </div>
          <span className={cn("my-3 flex h-px bg-blue-400")} />
          <div className={cn("flex items-center justify-center space-x-3")}>
            <div className={cn("h-8 w-8")}>
              <UseSvg
                className={cn("h-full w-full text-gray-700")}
                icon="do-not-iron"
                type="neck_labels"
                data-testid="h-full"
              />
            </div>
            <div className={cn("h-8 w-8")}>
              <UseSvg
                className={cn("h-full w-full text-gray-700")}
                icon="do-not-wash"
                type="neck_labels"
                data-testid="h-full-1"
              />
            </div>
            <div className={cn("h-8 w-8")}>
              <UseSvg
                className={cn("h-full w-full text-gray-700")}
                icon="chlorine-bleach"
                type="neck_labels"
                data-testid="h-full-2"
              />
            </div>
            <div className={cn("h-8 w-8")}>
              <UseSvg
                className={cn("h-full w-full text-gray-700")}
                icon="do-not-bleach"
                type="neck_labels"
                data-testid="h-full-3"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
